module.exports = __webpack_public_path__ + "img/22.9c2a04d5.jpg";